import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import CrearGestion from "./CrearGestion";
import AccionMejora from "./AccionMejora";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import ActualizaEstadoOmEvaluador from "../Evaluador/ActualizaOmNoAgrupadaEva";
import EnviarInformeOmGestion from "./InformeOm";

// =====================================================
// Componente para descripción expandible
// =====================================================
const DescripcionExpandible = ({ texto, limite = 150 }) => {
  const [expandido, setExpandido] = useState(false);

  if (!texto) {
    return <span style={{ fontSize: "12px" }}>Sin descripción</span>;
  }

  const esTextoLargo = texto.length > limite;

  const textoMostrar =
    expandido || !esTextoLargo ? texto : `${texto.substring(0, limite)}...`;

  return (
    <div
      style={{
        fontSize: "12px",
        lineHeight: "1.5",
        minWidth: "250px",
      }}
    >
      <span>{textoMostrar}</span>

      {esTextoLargo && (
        <button
          type="button"
          onClick={() => setExpandido(!expandido)}
          className="btn btn-link p-0 ml-1"
          style={{
            fontSize: "12px",
            textDecoration: "none",
            verticalAlign: "baseline",
          }}
        >
          {expandido ? "Leer menos" : "Leer más"}
        </button>
      )}
    </div>
  );
};

// =====================================================
// Componente principal
// =====================================================
function OmNoAgrupadas() {
  const cookie = new Cookies();

  const [list1, setList1] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // =====================================================
  // Construcción segura del endpoint
  // =====================================================
  const urlendpoint = useMemo(() => {
    const tipoUsuario = cookie.get("tipo_Usuario");

    console.log("TIPO USUARIO:", tipoUsuario);

    if (tipoUsuario == 1 || tipoUsuario == 6) {
      return "https://suadesarrollo.azurewebsites.net/api/ObtenerOportunidadMejora/0/a";
    }

    if (tipoUsuario == 4) {
      return "https://suadesarrollo.azurewebsites.net/api/ObtenerOportunidadMejora/0";
    }

    if (tipoUsuario == 2 || tipoUsuario == 3) {
      const institucionId = cookie.get("institucionid");

      console.log("INSTITUCION:", institucionId);

      return `https://suadesarrollo.azurewebsites.net/api/ObtenerOportunidadMejoraAgrupacion/0/${institucionId}`;
    }

    return null;
  }, []);

  // =====================================================
  // Consumo API
  // =====================================================
  useEffect(() => {
    if (!urlendpoint) {
      setList1([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: urlendpoint,
    })
      .then((response) => {
        console.log("Respuesta API:", response.data);

        const data = response.data;

        if (Array.isArray(data)) {
          setList1(data);
        } else {
          console.warn("La API no devolvió un arreglo:", data);

          setList1([]);
        }

        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error API:", error);

        setList1([]);
        setIsLoading(false);
      });
  }, [urlendpoint]);

  // =====================================================
  // Tipo de usuario
  // =====================================================
  const tipoUsuario = cookie.get("tipo_Usuario");

  // =====================================================
  // Columnas
  // =====================================================
  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
      },

      {
        Header: "Estado Oportunidad",
        accessor: "estadoOportunidad",
      },

      {
        Header: "Origen",
        accessor: "origen",
      },

      // =================================================
      // DESCRIPCIÓN
      // =================================================
      {
        Header: "Descripción",
        accessor: "descripcion",
        Cell: ({ value }) => (
          <DescripcionExpandible texto={value} limite={150} />
        ),
      },

      {
        Header: "Institución",
        accessor: "razon_Social",
      },

      {
        Header: "Asignado",
        accessor: "asignacion",
      },

      // =================================================
      // AÑADIR
      // =================================================
      {
        Header: "Añadir",
        Cell: ({ row }) =>
          tipoUsuario == 2 ? (
            <CrearGestion
              descripcion={row.original.descripcion}
              idOm={row.original.id}
            />
          ) : null,
      },

      // =================================================
      // CONSULTA
      // =================================================
      {
        Header: "Consulta",
        Cell: ({ row }) => <AccionMejora idOm={row.original.id} />,
      },

      // =================================================
      // HALLAZGO EVALUADOR
      // =================================================
      {
        Header: "Hallazgo evaluador",
        Cell: ({ row }) => (
          <ActualizaEstadoOmEvaluador idOm={row.original.id} />
        ),
      },
    ],
    [tipoUsuario],
  );

  // =====================================================
  // Data protegida
  // =====================================================
  const data = useMemo(() => {
    return Array.isArray(list1) ? list1 : [];
  }, [list1]);

  // =====================================================
  // React Table
  // =====================================================
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,

    // Paginación
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    gotoPage,
    pageOptions,
    pageCount,

    // Filtro
    setGlobalFilter,

    // Estado
    state: { globalFilter, pageIndex, pageSize },

    // Cambiar cantidad por página
    setPageSize,
  } = useTable(
    {
      columns,
      data,

      initialState: {
        pageSize: 10,
        pageIndex: 0,
      },
    },
    useGlobalFilter,
    usePagination,
  );

  // =====================================================
  // Loading
  // =====================================================
  if (isLoading) {
    return <div className="text-center mt-5">Cargando información...</div>;
  }

  // =====================================================
  // Agrupar
  // =====================================================
  const handleAgrupar = () => {
    window.location.href = "/#/OmGrupo";
  };

  // =====================================================
  // Render
  // =====================================================
  return (
    <div className="container">
      <div className="card shadow mb-2">
        {/* ============================================= */}
        {/* HEADER */}
        {/* ============================================= */}
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Información No Agrupada
          </h6>
        </div>

        {/* ============================================= */}
        {/* BODY */}
        {/* ============================================= */}
        <div className="card-body">
          {/* =========================================== */}
          {/* ENVIAR INFORME */}
          {/* =========================================== */}
          <EnviarInformeOmGestion />

          <hr />

          {/* =========================================== */}
          {/* BUSCADOR */}
          {/* =========================================== */}
          <div className="row mb-3">
            <div className="col-md-9">
              <input
                type="text"
                placeholder="Buscar..."
                value={globalFilter || ""}
                onChange={(e) => setGlobalFilter(e.target.value)}
                className="form-control"
              />
            </div>

            <div className="col-md-3 mt-2 mt-md-0">
              <button onClick={handleAgrupar} className="btn btn-primary w-100">
                Agrupar
              </button>
            </div>
          </div>

          {/* =========================================== */}
          {/* INFORMACIÓN DE REGISTROS */}
          {/* =========================================== */}
          <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
            <div className="mb-2">
              <span style={{ fontSize: "13px" }}>
                Total registros: <strong>{data.length}</strong>
              </span>
            </div>

            <div className="d-flex align-items-center mb-2">
              <span className="mr-2" style={{ fontSize: "13px" }}>
                Registros por página:
              </span>

              <select
                className="form-control"
                style={{
                  width: "90px",
                }}
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
                <option value={50}>50</option>
              </select>
            </div>
          </div>

          {/* =========================================== */}
          {/* TABLA */}
          {/* =========================================== */}
          <div className="table-responsive">
            <table
              {...getTableProps()}
              className="table table-bordered table-hover"
            >
              {/* ======================================= */}
              {/* HEADER */}
              {/* ======================================= */}
              <thead className="thead-light">
                {headerGroups.map((headerGroup) => (
                  <tr
                    {...headerGroup.getHeaderGroupProps()}
                    key={headerGroup.id}
                  >
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps()}
                        key={column.id}
                        style={{
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>

              {/* ======================================= */}
              {/* BODY */}
              {/* ======================================= */}
              <tbody {...getTableBodyProps()}>
                {page.length > 0 ? (
                  page.map((row) => {
                    prepareRow(row);

                    return (
                      <tr {...row.getRowProps()} key={row.id}>
                        {row.cells.map((cell) => (
                          <td
                            {...cell.getCellProps()}
                            key={cell.column.id}
                            style={{
                              verticalAlign: "middle",
                            }}
                          >
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No hay registros disponibles
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* =========================================== */}
          {/* PAGINACIÓN */}
          {/* =========================================== */}

          <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
            {/* ========================================= */}
            {/* ANTERIOR */}
            {/* ========================================= */}
            <button
              onClick={previousPage}
              disabled={!canPreviousPage}
              className="btn btn-primary mb-2"
            >
              <i className="fas fa-chevron-left mr-1"></i>
              Anterior
            </button>

            {/* ========================================= */}
            {/* PÁGINA ACTUAL */}
            {/* ========================================= */}
            <div className="d-flex align-items-center mb-2">
              <span
                className="mr-2"
                style={{
                  fontSize: "14px",
                }}
              >
                Página <strong>{pageIndex + 1}</strong> de{" "}
                <strong>{pageOptions.length}</strong>
              </span>

              {/* Selector de página */}
              <select
                className="form-control"
                style={{
                  width: "80px",
                }}
                value={pageIndex}
                onChange={(e) => gotoPage(Number(e.target.value))}
              >
                {pageOptions.map((pageNumber) => (
                  <option key={pageNumber} value={pageNumber}>
                    {pageNumber + 1}
                  </option>
                ))}
              </select>
            </div>

            {/* ========================================= */}
            {/* SIGUIENTE */}
            {/* ========================================= */}
            <button
              onClick={nextPage}
              disabled={!canNextPage}
              className="btn btn-primary mb-2"
            >
              Siguiente
              <i className="fas fa-chevron-right ml-1"></i>
            </button>
          </div>

          {/* =========================================== */}
          {/* INFORMACIÓN DE PÁGINA */}
          {/* =========================================== */}

          {pageCount > 0 && (
            <div
              className="text-center mt-2"
              style={{
                fontSize: "12px",
                color: "#6c757d",
              }}
            >
              Mostrando <strong>{page.length}</strong> registros en esta página
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default OmNoAgrupadas;
